<!--报表 历史出库单 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium" label-suffix="：">
          <el-form-item label="产品名称">
            <el-input v-model="searchForm.PRODUCT_NAME" style="width: 200px"></el-input>
          </el-form-item>
          <template v-if="currentOrderFlag === 0">
            <el-form-item label="客户">
              <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择" clearable @change="onTCChange">
                <el-option v-for="item in companyLists" :key="item.ID" :label="item.AB_NAME"
                  :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目点">
              <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
                <el-option v-for="item in projectList" :key="item.value" :label="item.PROJECT_NAME"
                  :value="item.PROJECT_ID">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="客户" v-else>
            <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出库日期">
            <el-date-picker v-model="searchForm.ENTRY_DATE" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="订单日期">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="打印次数">
            <el-input v-model="searchForm.PRINT_TIME" placeholder="请输入内容" oninput="value=value.replace(/[^0-9]/g,'')"
              clearable style="width: 200px">
            </el-input>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.ORDER_ID" placeholder="请输入内容" oninput="value=value.replace(/[^0-9]/g,'')"
              clearable style="width: 200px">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="onSubmit" :loading="loadSearch">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain class="btn" @click="exportData" v-if="fun_dic[113020101]">导出</el-button>
          </el-form-item>
          <template v-if="currentOrderFlag === 0">
            <el-form-item>
              <el-button type="primary" plain class="btn" @click="exportOldData" v-if="fun_dic[113020102]">
                旧版导出
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain class="btn" @click="跳转批量退库页面()" v-if="fun_dic[113020103]">批量退库</el-button>
            </el-form-item>
          </template>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick">
          <el-tab-pane label="团餐客户">
            <el-table border stripe :data="tableData" max-height="520">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
              <el-table-column prop="SEND_DAY" label="订单日期" min-width="70px"></el-table-column>
              <el-table-column prop="DELIVER_DAY" label="出库日期" min-width="70px"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="TC_NAME" label="团餐公司"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口"></el-table-column>
              <el-table-column prop="DELIVER_TOTAL_FEE" label="总金额"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" width="100px"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="detail(scope.row)">查看</el-button>
                  <el-button size="small" type="text" @click="exportDetail(scope.row)">导出</el-button>
                  <el-button size="small" type="text" @click="downloadFile(scope.row)"
                    v-if="scope.row.FILE_NAME">下载出库单</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商客户">
            <el-table border stripe :data="tableData" max-height="520">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
              <el-table-column prop="SEND_DAY" label="订单日期" min-width="70px"></el-table-column>
              <el-table-column prop="DELIVER_DAY" label="出库日期" min-width="70px"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="SUPPLIER_CLIENT_NAME" label="客户名称"></el-table-column>
              <el-table-column prop="DELIVER_TOTAL_FEE" label="总金额"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" width="100px"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="detail(scope.row)">查看</el-button>
                  <el-button size="small" type="text" @click="downloadFile(scope.row)"
                    v-if="scope.row.FILE_NAME">下载入库单</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  historyOutFun, exportHisOutData, exportHisOutOldData, exportStockRowDetail,
} from 'api/warehouseManager';
import { supplierCusFun } from 'api/customerManage';
import { haveDSXMDFun } from 'api/sellOrder';
import { getActionFun } from '@/assets/api/login';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      PAGE_ID: '1130201',
      fun_dic: { 113020101: 0, 113020102: 0, 113020103: 0 },
      // loading: false,
      loadSearch: false,
      allProjectList: [],
      projectList: [],
      searchForm: {
        DAY_INTERVAL: [date(new Date(), '%F'), date(new Date(), '%F')],
      },
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      companyLists: [],
      typeList: ['正常出库', '补出库'],
      exportDataDialog: false,
      value1: [],
      currentOrderFlag: 0,
      supplierList: [],
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.HISTORY_OUT_DATA_CONDITION.CONDITION) {
      this.searchForm = this.HISTORY_OUT_DATA_CONDITION.CONDITION;
      this.currentPage = this.HISTORY_OUT_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryPro();
    this.querySupplierList();
    this.queryBeforeFun();
  },
  computed: {
    HISTORY_OUT_DATA_CONDITION () {
      return this.$store.state.HISTORY_OUT_DATA_CONDITION;
    },
  },
  methods: {
    onTCChange (e) {
      this.searchForm.PROJECT_ID = '';
      if (e) this.projectList = [...this.allProjectList.filter(({ TC_ID }) => TC_ID == e)];
      else this.projectList = [...this.allProjectList];
    },
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // ----拉取项目点
    queryPro () {
      haveDSXMDFun().then((result) => {
        this.allProjectList = result.length > 0 ? result[0].project : [];
        this.projectList = [...this.allProjectList];
        this.companyLists = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    跳转批量退库页面 () {
      this.$router.push({ path: '/batchReturnOfInventory' });
    },
    // 旧版导出
    exportOldData () {
      const params = {};
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.ENTRY_DATE != null && this.searchForm.ENTRY_DATE.length == 2) {
        params.DELIVER_START_DAY = this.searchForm.ENTRY_DATE[0];
        params.DELIVER_END_DAY = this.searchForm.ENTRY_DATE[1];
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      // this.loading = true
      exportHisOutOldData(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        // this.loading = false
        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        // this.loading = false
        document.body.style.cursor = 'default';
      });
    },
    // 打开导出模态框
    openexportDataDia () {
      this.exportDataDialog = true;
    },
    closeDia () {
      this.exportDataDialog = false;
      this.value1 = [];
    },
    exportData () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {};
          if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
            params.START_DATE = this.searchForm.DAY_INTERVAL[0];
            params.END_DATE = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.PROJECT_ID) {
            params.PROJECT_ID = this.searchForm.PROJECT_ID;
          }
          if (this.searchForm.ENTRY_DATE != null && this.searchForm.ENTRY_DATE.length == 2) {
            params.DELIVER_START_DAY = this.searchForm.ENTRY_DATE[0];
            params.DELIVER_END_DAY = this.searchForm.ENTRY_DATE[1];
          }
          if (this.currentOrderFlag == 1) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          exportHisOutData(params).then((result) => {
            if (result[0] && result[0].TASK_CREATED_SUCCESSFULLY) {
              this.$util.getUnreadInformation(this);
              this.$confirm(this.$util.appointmentMessage, '温馨提示', {
                confirmButtonText: '确定', cancelButtonText: '取消', type: 'success', dangerouslyUseHTMLString: true,
              }).then(() => {
                this.$router.push({ name: 'appointmentHandling' });
              }).catch(() => {
                this.$message.show({ type: 'info', text: '取消操作' });
              });
            } else {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            }
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    // -----------------------------拉取数据
    queryData () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
        params.SUB_TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      // ----------------筛选条件
      if (this.searchForm.ENTRY_DATE != null && this.searchForm.ENTRY_DATE.length == 2) {
        params.DELIVER_START_DAY = this.searchForm.ENTRY_DATE[0];
        params.DELIVER_END_DAY = this.searchForm.ENTRY_DATE[1];
      }
      if (this.currentOrderFlag == 1) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.PRINT_TIME) {
        params.PRINT_TIME = this.searchForm.PRINT_TIME;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      this.loadSearch = true;
      historyOutFun(params).then((result) => {
        this.tableData = result[0].list;
        this.totalCount = result[0].TOTAL_COUNT;
        this.$store.dispatch('SET_HISTORY_OUT_DATA_CONDITION', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
        });
        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------查看
    detail (row) {
      this.$router.push({ path: '/historyDetail/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
      sessionStorage.setItem('DELIVER_ID', row.DELIVER_ID);
      sessionStorage.setItem('currentOrderFlag', this.currentOrderFlag);
    },
    // ---------------------------筛选
    onSubmit () {
      this.currentPage = 1;
      if (!((this.searchForm.ENTRY_DATE != null && this.searchForm.ENTRY_DATE.length == 2) || (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2))) {
        this.$message.show({ text: '请至少选择出库日期或订单日期中的一项', type: 'warning' });
        return;
      }
      this.queryData();
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    handleTabClick (tab, event) {
      this.currentOrderFlag = Number(tab.index);
      this.queryData();
    },
    querySupplierList () {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierList = res[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 导出
    async exportDetail (row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
        DELIVER_ID: row.DELIVER_ID,
      };
      const filepath = await exportStockRowDetail(params);
      window.location.href = filepath[0].FILE_PATH;
    },
    downloadFile ({ FILE_NAME }) {
      window.open(this.$util.getURLLocalHost(`/file/scmStockOutFile/${FILE_NAME}`));
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/historyOut.vue